import PublicNavbar from "../components/PublicNavbar";
import Footer from "../components/Footer";

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-[#07090E]">
      <PublicNavbar />

      <section className="pt-32 pb-20 sm:pt-40">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1
            className="text-3xl sm:text-4xl font-bold text-white mb-8"
            style={{ fontFamily: "'Space Grotesk', sans-serif" }}
          >
            Politique de confidentialite
          </h1>

          <div className="space-y-8 text-slate-300 text-sm leading-relaxed">
            <div>
              <h2 className="text-lg font-semibold text-white mb-3">1. Introduction</h2>
              <p>ServeurOnline s'engage a proteger la vie privee de ses utilisateurs. La presente politique de confidentialite explique comment nous collectons, utilisons et protegeons vos donnees personnelles conformement au Reglement General sur la Protection des Donnees (RGPD).</p>
            </div>

            <div>
              <h2 className="text-lg font-semibold text-white mb-3">2. Donnees collectees</h2>
              <p>Nous collectons les donnees suivantes dans le cadre de l'utilisation de notre service :</p>
              <ul className="list-disc list-inside mt-2 space-y-1 text-slate-400">
                <li><strong className="text-slate-300">Donnees d'identification</strong> : nom, adresse email, nom de l'entreprise</li>
                <li><strong className="text-slate-300">Donnees techniques</strong> : adresses IP des serveurs surveilles, noms d'hotes, versions des systemes d'exploitation</li>
                <li><strong className="text-slate-300">Donnees de sauvegarde</strong> : statuts, dates, tailles et durees des sauvegardes remontees par les agents</li>
                <li><strong className="text-slate-300">Donnees de facturation</strong> : historique des transactions (les donnees bancaires sont traitees exclusivement par Stripe)</li>
                <li><strong className="text-slate-300">Donnees de connexion</strong> : journaux d'acces, adresses IP de connexion</li>
              </ul>
            </div>

            <div>
              <h2 className="text-lg font-semibold text-white mb-3">3. Finalites du traitement</h2>
              <p>Les donnees collectees sont utilisees pour :</p>
              <ul className="list-disc list-inside mt-2 space-y-1 text-slate-400">
                <li>Fournir et maintenir le service de monitoring de sauvegardes</li>
                <li>Envoyer des alertes et notifications par email</li>
                <li>Generer des rapports et statistiques</li>
                <li>Gerer la facturation et les abonnements</li>
                <li>Ameliorer le service et l'experience utilisateur</li>
                <li>Repondre aux demandes de support</li>
              </ul>
            </div>

            <div>
              <h2 className="text-lg font-semibold text-white mb-3">4. Base legale du traitement</h2>
              <p>Le traitement des donnees repose sur :</p>
              <ul className="list-disc list-inside mt-2 space-y-1 text-slate-400">
                <li><strong className="text-slate-300">L'execution du contrat</strong> : necessaire a la fourniture du service</li>
                <li><strong className="text-slate-300">Le consentement</strong> : pour l'envoi de communications marketing</li>
                <li><strong className="text-slate-300">L'interet legitime</strong> : pour l'amelioration du service et la securite</li>
              </ul>
            </div>

            <div>
              <h2 className="text-lg font-semibold text-white mb-3">5. Duree de conservation</h2>
              <p>Les donnees personnelles sont conservees pour la duree necessaire a la realisation des finalites decrites ci-dessus :</p>
              <ul className="list-disc list-inside mt-2 space-y-1 text-slate-400">
                <li>Donnees du compte : pendant la duree de l'abonnement + 1 an apres la cloture</li>
                <li>Historique de sauvegardes : 1 an glissant</li>
                <li>Donnees de facturation : 10 ans (obligations legales)</li>
                <li>Donnees de connexion : 1 an</li>
              </ul>
            </div>

            <div>
              <h2 className="text-lg font-semibold text-white mb-3">6. Partage des donnees</h2>
              <p>Vos donnees ne sont jamais vendues a des tiers. Elles peuvent etre partagees avec :</p>
              <ul className="list-disc list-inside mt-2 space-y-1 text-slate-400">
                <li><strong className="text-slate-300">Stripe</strong> : pour le traitement des paiements</li>
                <li><strong className="text-slate-300">Hebergeur</strong> : pour le stockage et l'hebergement du service</li>
                <li><strong className="text-slate-300">Autorites competentes</strong> : en cas d'obligation legale</li>
              </ul>
            </div>

            <div>
              <h2 className="text-lg font-semibold text-white mb-3">7. Securite des donnees</h2>
              <p>Nous mettons en oeuvre des mesures techniques et organisationnelles appropriees pour proteger vos donnees :</p>
              <ul className="list-disc list-inside mt-2 space-y-1 text-slate-400">
                <li>Chiffrement des communications (HTTPS/TLS)</li>
                <li>Chiffrement des mots de passe (bcrypt)</li>
                <li>Isolation des donnees entre utilisateurs (architecture multi-tenant)</li>
                <li>Authentification par tokens JWT</li>
                <li>Hebergement en centres de donnees certifies</li>
              </ul>
            </div>

            <div>
              <h2 className="text-lg font-semibold text-white mb-3">8. Vos droits</h2>
              <p>Conformement au RGPD, vous disposez des droits suivants :</p>
              <div className="mt-2 space-y-2">
                {[
                  { right: "Droit d'acces", desc: "Obtenir une copie de vos donnees personnelles" },
                  { right: "Droit de rectification", desc: "Corriger des donnees inexactes ou incompletes" },
                  { right: "Droit a l'effacement", desc: "Demander la suppression de vos donnees" },
                  { right: "Droit a la limitation", desc: "Limiter le traitement de vos donnees" },
                  { right: "Droit a la portabilite", desc: "Recevoir vos donnees dans un format structure" },
                  { right: "Droit d'opposition", desc: "Vous opposer au traitement de vos donnees" },
                ].map((item, i) => (
                  <div key={i} className="flex gap-3 items-start p-3 rounded-lg bg-[#0D111A] border border-slate-800/60">
                    <span className="text-cyan-400 font-semibold text-xs mt-0.5 shrink-0">{item.right}</span>
                    <span className="text-slate-400">{item.desc}</span>
                  </div>
                ))}
              </div>
              <p className="mt-3">Pour exercer ces droits, contactez-nous a : <span className="text-cyan-400">contact@serveuronline.com</span></p>
            </div>

            <div>
              <h2 className="text-lg font-semibold text-white mb-3">9. Cookies</h2>
              <p>ServeurOnline utilise des cookies strictement necessaires au fonctionnement du service (authentification, preferences). Aucun cookie publicitaire ou de tracking n'est utilise.</p>
            </div>

            <div>
              <h2 className="text-lg font-semibold text-white mb-3">10. Modifications</h2>
              <p>Nous nous reservons le droit de modifier cette politique de confidentialite a tout moment. Les modifications seront publiees sur cette page avec une date de mise a jour.</p>
            </div>

            <div className="pt-4 border-t border-slate-800/60">
              <p className="text-slate-500 text-xs">Derniere mise a jour : Fevrier 2026</p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
